// web/src/services/usageTracker.ts
// Tracks photo scoring usage in localStorage for free-tier gating
// After 25 photos scored without auth, triggers account creation prompt

const STORAGE_KEY = 'frame_usage';

interface UsageData {
  totalPhotosScored: number;
  sessionsCompleted: number;
  firstUseDate: string;
  lastUseDate: string;
}

function getDefault(): UsageData {
  return {
    totalPhotosScored: 0,
    sessionsCompleted: 0,
    firstUseDate: new Date().toISOString(),
    lastUseDate: new Date().toISOString(),
  };
}

export const UsageTracker = {
  get(): UsageData {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch { /* corrupted data — reset */ }
    return getDefault();
  },

  recordSession(photoCount: number): void {
    const data = this.get();
    data.totalPhotosScored += photoCount;
    data.sessionsCompleted += 1;
    data.lastUseDate = new Date().toISOString();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },

  requiresAuth(): boolean {
    return this.get().totalPhotosScored >= 25;
  },

  photosRemaining(): number {
    return Math.max(0, 25 - this.get().totalPhotosScored);
  },

  reset(): void {
    localStorage.removeItem(STORAGE_KEY);
  },
};
